import '@trendmicro/react-buttons/dist/react-buttons.css';
import '@trendmicro/react-checkbox/dist/react-checkbox.css';
import '@trendmicro/react-dropdown/dist/react-dropdown.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(<App />, document.querySelector('#container'));



// WEBPACK FOOTER //
// ./index.js